import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { fetch } from '@ngrx/router-store/data-persistence';
import { map, tap } from 'rxjs/operators';

import { NotificationService } from '@core/shared/util';

import { ShoppingCartService } from '../services';

import { ShoppingCartActions } from './shopping-cart.actions';

@Injectable()
export class ShoppingCartEffects {
  fetchShoppingCarts$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ShoppingCartActions.fetchShoppingCarts),
      fetch({
        run: () => {
          return this.shoppingCartService
            .fetchShoppingCarts()
            .pipe(map((shoppingCarts) => ShoppingCartActions.fetchShoppingCartsSuccess({ shoppingCarts })));
        },
        onError: () => ShoppingCartActions.fetchShoppingCartsError(),
      }),
    );
  });

  requestShoppingCart$ = createEffect(() => {
    return this.actions$.pipe(
      ofType(ShoppingCartActions.requestShoppingCart),
      fetch({
        id: ({ shoppingCartId }) => shoppingCartId,
        run: ({ shoppingCartId }) => {
          return this.shoppingCartService.requestShoppingCart(shoppingCartId).pipe(
            map(({ isImmediateApproval }) =>
              ShoppingCartActions.requestShoppingCartSuccess({ shoppingCartId, isImmediateApproval }),
            ),
            tap(({ isImmediateApproval }) => {
              this.notificationService.toastSuccess(
                isImmediateApproval
                  ? 'Eine Anforderung wurde aus dem Warenkorb erstellt und freigegeben.'
                  : 'Eine Anforderung wurde aus dem Warenkorb erstellt.',
              );
            }),
          );
        },
        onError: () => ShoppingCartActions.requestShoppingCartError(),
      }),
    );
  });

  constructor(
    private readonly actions$: Actions,
    private readonly shoppingCartService: ShoppingCartService,
    private readonly notificationService: NotificationService,
  ) {}
}
